export const transformApiKeyList = (raw) => ({
  merchant_id: raw?.merchant_uuid || '',
  api_key_id: raw?.uuid || '',
  callback_url: raw?.callback_url || '',
  queue_code: raw?.queue_code || '',
  status: raw?.status || '',
  token: raw?.token || '',
  api_type: raw?.api_type || '',
});
